import { LaydownLogRow } from "./LaydownLogRow";
export class LaydownLogFilterParams {
    _ALL?: string;
    jobNumber?: string;
    contact?: string;
    space?: string;
    dateIn?: string;
     estDateOut?: string;
    dateOut?: string;
    loggedBy?: string;
    storageFacility?: string;
  
    public constructor(init?: Partial<LaydownLogRow>) {
      if (init) {
        // Safely assign properties to this instance
        Object.assign(this, init);
      }
    }
  }
  